import { 
    VBtn
} from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v2'
import { formattingNumber } from '@/libs/util'
import PayImport from './Pay_Import'
import PopTip from '@/views/fin/salaryadministration/components/PopTip.vue'

import {
    getCustomerMonthSalaryTotalListApi, 
    pigeonholeApi, 
    postCustomerMonthSalaryTotalTransferWageApi,
    postCustomerSalaryPaymentApplyDeleteApi,
    postCustomeMonthSalaryTotalPaySalaryApi
} from '../service'
export default {
    props: {
        type: {
            type: [Number, String]
        },
        currentMonthShouldPay: {
            type: [Number, String]
        }
    },
    data() {
        return {
           //  list: [],
            get_loading: false,
            list_hash: {}
        }
    },
    computed: {
        list() {
            return this.list_hash[this.type]
        },
        table_fields() {
            const _this = this
            return [
                {
                    text: '名称',
                    align: 'center',
                    value: 'name',
                    width: 200,
                    fixed:'left',
                    render:(_, __, target) => {
                        return <VBtn 
                                    text
                                    on={{
                                        click:() => {
                                            _this.$emit('getDetail', target)
                                        }
                                    }}
                        >{target.name}{![0, 1].includes(target.pigeonhole_flag) && '（预估）'}</VBtn>
                    }
                },
                {
                    text: '计薪周期',
                    align: 'center',
                    value: 'memo',
                    width: 190,
                    render:(_, __, target) => {
                        return <span>{target.begin_date}~{target.end_date}</span> 
                    }
                },
                {
                    text: '发薪人数',
                    align: 'center',
                    value: 'customer_quantity',
                    width: 100,
                },
                {
                    text: '费用合计',
                    align: 'center',
                    type: 'money_field',
                    value: 'total_fee',
                    width: 160,
                    render:(_, __, target) => {
                        // 已确认和已归档
                        if (!target.confirm_customer && !target.pigeonhole_flag) {
                            return <span>
                                { formattingNumber(Number(target.total_fee) + Number(_this.currentMonthShouldPay || 0), 2)}
                       
                            </span> 
                        }
                        return <span>
                            {formattingNumber(target.total_fee, 2)}
                        </span> 
            
                    }
                },
                {
                    text: '归档时间',
                    align: 'center',
                    value: 'pigeonhole_time',
                    type: 'date_field',
                    format: 'YYYY-MM-DD HH:mm:ss',
                    width: 120,
                },
                {
                    fixed:'right',
                    value:'action',
                    width: 320,
                    text: '操作',
                    align: 'center',
                    type: 'button_g_field',
                    render:(_, __, target) => {
                      
                        return <div>
                            {!!this.disInput(target) && <VBtn color="primary" text x-small on={{
                                click:() => {
                                    if (target.pigeonhole_flag) {
                                        this.$vModal.warning({
                                            title:'提示',
                                            content: '归档后，不能导入数据！'
                                        })
                                        return 
                                    }
                                    this.$refs.payImport.show(target.id) 
                                }
                            }}>
                                数据导入
                            </VBtn>}
                            {!!this.disPigeonhole(target) && <VBtn color="primary" text x-small on={{
                                click:() => this.pigeonhole(target)
                            }}>
                                归档
                            </VBtn>}
                            {/* synchronization */}
                            {this.disCBS(target) && <VBtn color="primary" text x-small on={{
                                click:() => this.syncCBS(target)
                            }}>
                                同步CBS
                            </VBtn>}
                            {this.disSynchronization(target) && <VBtn color="primary" text x-small on={{
                                click:() => this.synchronization(target)
                            }}>
                                导入工资条
                            </VBtn>}
                            {this.disAbandon(target) && <span>
                                <VBtn color="error" text x-small on={{
                                    click:() => _this.abandon(target)
                                }}>
                                    撤回
                                    <PopTip showIcon size={14} title="撤回后上一版本的薪资审批流程将自动废弃"/>
                                </VBtn>
                                
                            </span>}
                        </div>
                    },
                  },
         ]
        }
    },
    methods: {
        disAbandon(target) {
            return !!target.pigeonhole_flag 
        },
        disSynchronization(target) {
            return !!target.pay_status
        },
        disCBS(target) {
            return target.pigeonhole_flag === 1 && target.pay_status === 'unpaid'
        },
        disInput(target) {
            return !target.pigeonhole_flag
        },
        disPigeonhole(target) {
            return !target.pigeonhole_flag
        },
        syncCBS(item) {
        
            
            this.$vModal.confirm({
                title: '提示',
                content: `确定同步CBS[${item.name}]？`,
                loading:true,
                onOk:({destroy, stopLoading}) => {
                    postCustomeMonthSalaryTotalPaySalaryApi({id:item.id}).then(() => {
                      this.$Message.success('数据提交成功！')  
                      this.getData(this.type)
                    }).finally(() => {
                        stopLoading()
                        destroy()
                    })
                }
            })
        },
        abandon(item) {
            this.$vModal.confirm({
                title: '提示',
                content: `确定废弃[${item.name}]？`,
                loading:true,
                onOk:({destroy, stopLoading}) => {
                    postCustomerSalaryPaymentApplyDeleteApi({customer_month_salary_total_id:item.id}).then(() => {
                      this.$Message.success('数据提交成功！')  
                      this.getData(this.type)
                    }).finally(() => {
                        stopLoading()
                        destroy()
                    })
                }
            })
        },
        synchronization(item) {
            this.$vModal.confirm({
                title: '提示',
                content: `是否确定同步[${item.name}]？`,
                loading:true,
                onOk:({destroy, stopLoading}) => {
                    postCustomerMonthSalaryTotalTransferWageApi({id:item.id}).then(() => {
                      this.$Message.success('数据提交成功！')  
                      this.getData(this.type)
                    }).finally(() => {
                        stopLoading()
                        destroy()
                    })
                }
            })
        },
        getData(type) {
            this.get_loading = true
            // this.list = []
            
            getCustomerMonthSalaryTotalListApi({type}).then(list => {
                this.$set(this.list_hash, type, list)
                //  this.list_hash[type] = list
                //  this.list = list
            }).finally(() => {
                this.get_loading = false
            })
        },
        pigeonhole(item) {
            this.$vModal.confirm({
                title: '提示',
                content: '归档后，员工薪资将不可继续更改，你确定这样操作吗？',
                loading:true,
                onOk:({
                  destroy,
                  stopLoading
                }) => {
                  pigeonholeApi({id: item.id}).then(() => {
                    this.$Message.success({
                      content: '操作成功!'
                    });
                    this.getData(this.type)
                  }).finally(() => {
                    stopLoading()
                    destroy()
                  })
                }
              })
        }
    },
    render() {
        return <div>
                <VTable
                    loading={this.get_loading}
                    headers={this.table_fields}
                    desserts={this.list}
                />
                <PayImport ref="payImport" 
                on={{
                    success: () => {
                        this.getData(this.type)
                    }
                }}/>
            </div>
    }
}